import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ShellService } from '../../services/shell.service';

@Component({
  selector: 'app-file-download',
  templateUrl: './file-download.component.html',
  styleUrls: ['./file-download.component.scss'],
  standalone: true,
  providers: [ShellService],
})
export class FileDownloadComponent implements OnInit {
  private _route = inject(ActivatedRoute);
  private _shellService = inject(ShellService);
  blob!: Blob;
  engagementId!: string;
  fileId!: string;
  fileType!: string;
  isLoading: boolean = true;
  downloadMessage: string = '';

  constructor() { }

  ngOnInit(): void {
    this.engagementId = this._route.snapshot.params['id'] as string;
    this.fileId = this._route.snapshot.params['fileId'] as string;
    this.fileType = this._route.snapshot.params['type'] as string;
    this.downloadContract();
  }

  downloadContract(): void {
    this._shellService.getUploadFileById(this.fileId).subscribe((file) => {
      if (file) {
        this._shellService.downloadFileServiceById(this.engagementId, this.fileId, this.fileType)
          .subscribe({
            next: (data) => {
              this.blob = new Blob([data], {
                type: 'application/octet-stream',
              });
              let downloadUrl = window.URL.createObjectURL(data);
              let link = document.createElement('a');
              link.href = downloadUrl;
              link.setAttribute('download', file.name);
              document.body.appendChild(link);
              link.click();
              this.downloadMessage = 'File downloaded successfully';
              this.isLoading = false;
            },
            error: (error) => {
              this.downloadMessage =
                'Error downloading file. Please contact iManageSupport@protiviti.com.';
              this.isLoading = false;
            },
            complete: () => { },
          });
      }
    });
  }
}
